import { render, staticRenderFns } from "./GiftcardBlob.vue?vue&type=template&id=51c108d0&scoped=true"
import script from "./GiftcardBlob.vue?vue&type=script&lang=js"
export * from "./GiftcardBlob.vue?vue&type=script&lang=js"
import style0 from "./GiftcardBlob.vue?vue&type=style&index=0&id=51c108d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c108d0",
  null
  
)

export default component.exports